export default __webpack_public_path__ + "static/bitemporal-stitched-112ed9f793f2a76fabf341b80002740e.svg";